/**
 * MenuButton 컴포넌트
 * 
 * FloatingUserMenu에서 사용하는 공통 버튼 컴포넌트
 * 중복 코드 제거 및 일관된 스타일 적용
 * 
 * 지원하는 버튼 타입:
 * - 일반 네비게이션 버튼
 * - 로그아웃 버튼 (isAction: true)
 * - 서브메뉴 트리거 버튼 (hasSubmenu: true)
 */
import React from 'react';
import { MENU_TEXT } from './menuConfig';

export default function MenuButton({
    item,
    isActive,
    onClick,
    currentTheme,
    lang = 'ko',
    userInfo,
    styles,
    onLogout,           // 로그아웃 콜백
    onSubmenuToggle,    // 서브메뉴 토글 콜백
    buttonRef,          // 외부 ref (서브메뉴 위치 계산용)
    isSubmenuOpen,      // 서브메뉴 열림 상태
}) {
    const {
        id,
        Icon,
        textKey,
        useIcon = true,
        useText = false,
        isDynamic,
        getPath,
        isAction,
        hasSubmenu
    } = item;

    // 동적 경로 처리
    const path = isDynamic && getPath ? getPath(userInfo) : item.path;

    // 텍스트 가져오기
    const text = MENU_TEXT[textKey]?.[lang] || textKey;

    // 스타일 계산
    const getButtonStyle = (active) => active
        ? { color: currentTheme.activeColor, borderColor: currentTheme.activeColor }
        : {};

    // 클래스명 계산
    const getButtonClassName = (active) => {
        const themeClass = currentTheme.activeColor === '#00ff00' ? 'dosTheme' : 'defaultTheme';
        return `${styles.floatingMenuBtn} ${active ? styles.active : ''} ${themeClass}`;
    };

    // 로그아웃 버튼 처리
    if (isAction && id === 'logout') {
        return (
            <button
                className={getButtonClassName(false)}
                onClick={onLogout}
                style={getButtonStyle(false)}
                title={text}
            >
                {useIcon && Icon && <Icon />}
            </button>
        );
    }

    // 서브메뉴 트리거 버튼 처리
    if (hasSubmenu) {
        const isButtonActive = isSubmenuOpen || isActive;

        return (
            <div style={{ position: 'relative' }}>
                <button
                    ref={buttonRef}
                    className={getButtonClassName(isButtonActive)}
                    onClick={onSubmenuToggle}
                    style={getButtonStyle(isButtonActive)}
                    title={text}
                >
                    {useIcon && Icon && <Icon />}
                </button>
            </div>
        );
    }

    // 일반 네비게이션 버튼
    return (
        <button
            className={getButtonClassName(isActive)}
            onClick={() => onClick(path)}
            style={getButtonStyle(isActive)}
            title={text}
        >
            {useIcon && Icon && <Icon />}
            {useText && !useIcon && text}
        </button>
    );
}

